"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHotelStatus = void 0;
const getCheapestRoomTotal_1 = require("./getCheapestRoomTotal");
/**
 * Determine the booking status of a hotel based on room availability
 * @param hotels - Array of hotel objects
 * @param formData - Form data containing trip and hotel selection information
 * @returns Hotel status: 'SOLD_OUT', 'ENQUIRE', 'RATES_AVAILABLE', or null
 */
const getHotelStatus = (hotels, formData) => {
    if (!formData?.hotel || !hotels || hotels.length === 0) {
        return null;
    }
    const hotel = hotels.find((h) => h.id === formData?.hotel?.where_when_who?.hotel?.id);
    if (!hotel) {
        return "";
    }
    const totalGuests = (formData?.trip?.number_of_golfers || 0) +
        (formData?.trip?.number_of_non_golfers || 0) +
        (formData?.trip?.pga_pros?.count || 0);
    const roomRateInfo = (0, getCheapestRoomTotal_1.getCheapestRoomTotal)(hotel, formData?.trip?.start_date || "", totalGuests, formData?.trip?.duration_days_nights || 0, formData?.discounts?.margin_discount_percentages?.hotels || 0);
    if (roomRateInfo.is_sold_out || roomRateInfo.room_ids.length === 0) {
        const allRoomIds = hotel?.rooms?.map((room) => room.id) || [];
        const soldOutRoomIds = roomRateInfo?.room_ids || [];
        const allRoomsMatch = allRoomIds.length > 0 &&
            allRoomIds.every((roomId) => soldOutRoomIds.includes(roomId));
        if (allRoomsMatch) {
            return "SOLD_OUT";
        }
        else {
            return "ENQUIRE";
        }
    }
    else {
        return "RATES_AVAILABLE";
    }
};
exports.getHotelStatus = getHotelStatus;
